export default __webpack_public_path__ + "static/295-73b95454da7f4a3acb0c331ddb701f4c.gif";